import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { InicioComponent } from './components/inicio/inicio.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/looking-glass',
    pathMatch: 'full'
  },
  {
    path: 'looking-glass',
    component: InicioComponent
  }
];
